var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mcont3"},[_c('div',[_c('div',[_c('h1',[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_c('br'),_c('span',[_vm._v("We will provide you with the IT solutions you need to support your customers' growth strategies")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }